



import { of, from, Observable } from 'rxjs';

import { map, mergeMap, catchError } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';


import * as ChargebeeActions from '../actions/chargebee-actions';
import { ChargebeeService } from '../shared/services/chargebee.service';

@Injectable()
export class ChargebeeEffects {

    constructor(
        private chargebeeService: ChargebeeService,
        private actions$: Actions,
    ) {
    }

    // Listen for the 'CHARGEBEE_GET' action
    get$: Observable<Action> = createEffect(() => 
    this.actions$.pipe(
        ofType(ChargebeeActions.CHARGEBEE_GET),
        mergeMap((action: ChargebeeActions.ChargebeeGetAction) => {
            // console.log(action.payload);
            return from(this.chargebeeService.getChargebeeProfile(
            )).pipe(
                map(data => new ChargebeeActions.ChargebeeSuccessAction(data)),
                catchError((err) => of(new ChargebeeActions.ChargebeeFailureAction(err)))
            );
        })
    ))  
}
